import { useQuery } from "react-query";
import useNetworkHeaders from "../../hooks/useNetworkHeaders";
import { getCrmListFieldDefinitions } from "../queries/getCrmListFieldDefinitions";

export default function useCrmListFieldDefinitions() {
  const headers = useNetworkHeaders();
  const { isLoading: isCrmListFieldDefinitionsLoading, data: crmListFieldDefinitions } = useQuery(
    "CrmListFieldDefinitions",
    {
      queryFn: getCrmListFieldDefinitions(headers),
    },
  );

  return {
    isCrmListFieldDefinitionsLoading,
    crmListFieldDefinitions,
  };
}
